import { createProviderStore2 } from '@/common/store/createProviderStore';
import { createWithEqualityFn } from 'zustand/traditional';
import isEqual from 'lodash/isEqual';
import { SameItem } from '../../../api';

const createCoudanInfoSlice = set => ({
    coudanRawData: null,
    setCoudanRawData: coudanRawData => set({ coudanRawData }),
    selectCoudanProducts: [],
    shopRecoItems: [],
    setSelectCoudanProducts: selectCoudanProducts => set({ selectCoudanProducts }),
    recoItems: [],
    setRecoItems: recoItems => set({ recoItems }),
    checkOutDetail: null,
    setCheckOutDetail: checkOutDetail => set({ checkOutDetail }),
    discountTip: null,
    setDiscountTip: discountTip => set({ discountTip }),
    curPopCartItem: null,
    setCurPopCartItem: curPopCartItem => set({ curPopCartItem }),
    showSpecPop: false,
    setShowSpecPop: showSpecPop => set({ showSpecPop }),
    extraInfo: null,
    setExtraInfo: extraInfo => set({ extraInfo }),
    thresholdStage: {
        currentStage: 0,
        progress: 0,
        totalStage: 2,
    } as {
        currentStage: number;
        progress: number;
        totalStage: number;
    },
    setThresholdStage: thresholdStage => set({ thresholdStage }),
    checkoutDetailVisible: false,
    makeUpPopupVisible: false,
    showDiscountDetail: false,
    sameItems: [] as SameItem[],
});

export type StoreType = ReturnType<typeof createCoudanInfoSlice>;

export const createUseCoudanInfoStore = () =>
    createWithEqualityFn<StoreType>()(
        (...args) => ({
            ...createCoudanInfoSlice(...args),
        }),
        isEqual
    );

export const { ProviderComponent: UseCoudanInfoProvider, useStore: useCoudanInfoStore } =
    createProviderStore2<ReturnType<typeof createUseCoudanInfoStore>>(createUseCoudanInfoStore);
